import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty, sortBy, orderBy, cloneDeep } from 'lodash';

import clsx from 'clsx';

import { ListBox, ListBoxToolbar, processListBoxData, processListBoxDragAndDrop } from '@progress/kendo-react-listbox';
import { Operators, TextFilter, NumericFilter, BooleanFilter } from '@progress/kendo-react-data-tools';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ConditionalFormat from './ConditionalFormat';
import OptimizationReportCustomListItem from './OptimizationReportCustomListItem.js';
import BobModal from '../../../components/BobModal';
import AutoComplete from '@material-ui/lab/Autocomplete';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { Button } from '@progress/kendo-react-buttons';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';

import { buildFilterLabel } from '../../../helpers/buildFilterLabel';
import KendoFilterGridModal from '../../../components/K2AFilterControl/KendoFilterGridModal';
import BobActionMenu from '../../../components/BobActionMenu';
import BobLoadingMask from '../../../components/BobLoadingMask';

import * as BobActions from '../../../actions/bobActions';
import * as ReportingActions from '../../../actions/reportingActions';

import * as classes from './ReportTabPane.module.css';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SELECTED_FIELD = 'selected';

const OptimizationReportTabPane = ({
    activeConfiguration,
    bobLoading,
    entities,
    equipmentList,
    fetchAllEntitySensors,
    fetchEntitySensors,
    fetchReportEquipment,
    fetchReportSystems,
    optimizationSensorsOrder,
    reportFilter,
    selectedTab,
    setEntities,
    setOptimizationSensorsOrder,
    setReportFilter,
    site,
    siteList,
    selectedClient,
    selectedEquipment,
    selectedSystems,
    selectedRules,
    selectedSpaceAirSensors,
    selectedOutsideAirSensors,
    setSelectedRules,
    selectedState,
    selectedStateItems,
    setSelectedState,
    setSelectedStateItems,
    setSelectedSpaceAirSensors,
    setSelectedOutsideAirSensors,
    setSelectedTab,
    setSelectedEquipments,
    setSelectedSystems,
    systemList,
    ...props
}) => {
    const [activeTab, setActiveTab] = useState({});
    let isRemovingTab = false;
    const [isApplyToAll, setIsApplyToAll]= useState(false);
    const [state, setState] = useState({
        available:   [],
        unavailable: [],
        draggedItem: {}
    });
    const [formatObj, setFormatObj] = useState({});
    const [formatList, setFormatList] = useState([{ 'operator': '', 'condition': '' }]);
    // const [formatList, setFormatList] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [formatKey, setFormatKey] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [formatType, setFormatType] = useState('');
    const [externalSensorOpen,setExternalSensorOpen] = useState(false);
    const [selectedSite, setSelectedSite] = useState('');
    const [externalEntityList, setExternalEntityList] = useState([]);
    const [selectedExternalEntity, setSelectedExternalEntity] = useState({});
    const [externalSensorList, setExternalSensorList] = useState([]);
    const [selectedExternalSensors, setSelectedExternalSensors] = useState([]);
    const [externalEntityLoading, setExternalEntityLoading] = useState(false);
    const [externalSensorsLoading, setExternalSensorsLoading] = useState(false);
    const [selectedSensorTypes, setSelectedSensorTypes] = useState([]);
    const [showFilterPanel, setShowFilterPanel] = useState(false);
    const [filterFields, setFilterFields] = useState();
    //const [filter, setFilter] = useState();
    const [filterText, setFilterText] = useState('');

    const [availableSearch, setAvailableSearch] = useState('');
    const [selectedSearch, setSelectedSearch] = useState('');
    const [sensorOrders, setSensorOrders] = useState([]);
    const [baseCopyTabs,setBaseCopyTabs] = useState([]);

    useEffect(() => {
        if (isEmpty(selectedEquipment) && isEmpty(selectedSystems)) {
            if (!isEmpty(entities)) {
                setEntities([]);
            }
        } else {
            if (!isEmpty(entities)) {
                if (!isApplyToAll) {
                    handleChange({selected: selectedTab});
                }
                else {
                    setIsApplyToAll(false);
                }
            }
        }
    },[entities]);

    useEffect(() => {
        if (activeConfiguration && activeConfiguration.id) {
            if (activeConfiguration.viewData.optimizationSensorsOrder) {
                setSensorOrders(activeConfiguration.viewData.optimizationSensorsOrder);
                setOptimizationSensorsOrder(activeConfiguration.viewData.optimizationSensorsOrder);
            }
        }
    }, [activeConfiguration]);

    useEffect(() => {
        if (!isEmpty(state.unavailable)) {
            let tempEntity = entities;
            let tempActiveTab = activeTab;
            const orderedUnavailable = orderBy(cloneDeep(state.unavailable), 'order', 'asc');
            orderedUnavailable.forEach((s, i) => s.order = i);
            
            const equipmentTypeSensorOrder = optimizationSensorsOrder.find(item => item.entityId === tempActiveTab.id); //.orderedSensors = orderedUnavailable;
            if (!equipmentTypeSensorOrder) {
                const orders = {
                    entityId:        tempActiveTab.id,
                    equipmentTypeId: tempActiveTab.isSystem ? tempActiveTab.systemType.id : tempActiveTab.equipmentType.id,
                    orderedSensors:  orderedUnavailable
                };
                sensorOrders.push(orders);
                setSensorOrders(sensorOrders);
                setOptimizationSensorsOrder(sensorOrders);
            }
            else {
                optimizationSensorsOrder.find(item => item.entityId === tempActiveTab.id).orderedSensors = orderedUnavailable;
                setSensorOrders(sensorOrders);
                setOptimizationSensorsOrder(sensorOrders);
            }

            tempActiveTab.sensors = [...state.available, ...orderedUnavailable];

            if (!isEmpty(activeTab))
                setActiveTab(tempActiveTab);

            tempEntity.forEach(async item => {
                if (item.id === tempActiveTab.id) {
                    item = tempActiveTab;
                    
                    setEntities(tempEntity);

                    if (item.sensors && !isEmpty(item.sensors)) {
                        const index = item.sensors.findIndex(
                            (dataItem) => dataItem.selected
                        );

                        if (index >= 0) {
                            if (item.sensors[index] && item.sensors[index].conditionalFormats) {
                                setFormatList(item.sensors[index].conditionalFormats);
                            } else {
                                setFormatList([{ 'operator': '', 'condition': '' }]);
                            }
                        }
                    } else {
                        setFormatList([{ 'operator': '', 'condition': '' }]);
                    }
                }
            });
        }
    },[state.unavailable]);

    useEffect(() => {
        if (!isEmpty(formatList)) {
            let tempEntity = entities;
            let tempActiveTab = activeTab;

            if (!isEmpty(activeTab))
                setActiveTab(tempActiveTab);

            tempEntity.forEach(async item => {
                if (item.id === tempActiveTab.id) {
                    item = tempActiveTab;

                    if (item.sensors) {
                        const index = item.sensors.findIndex(
                            (dataItem) => dataItem.selected
                        );
                    
                        item.sensors[index] = {
                            ...item.sensors[index],
                            conditionalFormats: formatList
                        };
                    }
                    setEntities(tempEntity);
                }
            });
            
            let { unavailable } = { ...state };
            let index = unavailable.findIndex(item => item.selected);
            if (index >= 0) {
                unavailable[index].conditionalFormats = formatList;

                setState({
                    ...state,
                    unavailable
                });
            }
        }
    },[formatList]);

    useEffect(() => {
        setFilterText(buildFilterLabel(reportFilter, filterFields));
    }, [reportFilter, filterFields, setFilterText]);
    
    const handleChange = async (e, newValue) => {
        let index = newValue === 0 ? newValue : e.selected;
        if (index >= entities.length) {
            index = entities.length - 1;
        }
                
        setSelectedTab(index);

        let selectedEntity = entities[index] ? entities[index] : {};
        if (selectedEntity.sensors) {
            let unavailableSensors = selectedEntity.sensors.filter(s => !s.available);
            unavailableSensors.forEach((item, index) => {
                // first check to see if the entity already is in the list
                const foundSensors = optimizationSensorsOrder.find(so => so.entityId === selectedEntity.id); // && so.equipmentTypeId === selectedEntity.isSystem ? selectedEntity.systemType.id : selectedEntity.equipmentType.id);
                if (foundSensors) {
                    let sensor = foundSensors.orderedSensors.find(sensor => sensor.id === item.id);
                    if (!sensor) {
                        sensor = foundSensors.orderedSensors.find(sensor => sensor.sensorType.id === item.sensorType.id);
                    }
                    if (sensor) {
                        item.order = sensor.order;
                    }
                    else {
                        item.order = index;
                    }
                }
                else {
                    const baseType = baseCopyTabs.find(bt => bt.entityType === selectedEntity.isSystem ? selectedEntity.systemType.id : selectedEntity.equipmentType.id);

                    let typeSensor;
                    if (baseType) {
                        typeSensor = baseType;
                    }
                    else {
                        typeSensor = optimizationSensorsOrder.find(so => so.equipmentTypeId === selectedEntity.equipmentType.id);
                    }

                    if (typeSensor) {
                        // by sensor type id
                        const sensorList = typeSensor.orderedSensors;
                        const sensor = sensorList.find(os => os.sensorType.id === item.sensorType.id);
                        if (sensor) {
                            item.order = sensor.order;
                        }
                        else 
                        {
                            item.order = index;
                        }
                    }
                    else {
                        item.order = index;
                    }
                }
            });

            if (optimizationSensorsOrder.find(so => so.entityId === selectedEntity.id)) { // && so.equipmentTypeId === selectedEntity.isSystem ? selectedEntity.systemType.id : selectedEntity.equipmentType.id)) {
                optimizationSensorsOrder.find(item => item.entityId === selectedEntity.id).orderedSensors = unavailableSensors; // && item.equipmentTypeId === selectedEntity ? selectedEntity.systemType.id : selectedEntity.equipmentType.id).orderedSensors = unavailableSensors;
                setSensorOrders(sensorOrders);
                setOptimizationSensorsOrder(sensorOrders);
            }
            else {
                const orders = {
                    entityId:        selectedEntity.id,
                    equipmentTypeId: selectedEntity.isSystem ? selectedEntity.systemType.id : selectedEntity.equipmentType.id,
                    orderedSensors:  unavailableSensors
                };
                sensorOrders.push(orders);
                setSensorOrders(sensorOrders);
                setOptimizationSensorsOrder(sensorOrders);
            }

            setState({
                available:   orderBy(selectedEntity.sensors.filter(nv => nv.available), 'name', 'asc'),
                unavailable: unavailableSensors,
                draggedItem: {}
            });
        } else {
            let sensors = await fetchEntitySensors(site.id, selectedEntity.id);
            sensors.forEach(s => {
                s.available = true;
                s.order = -1;
            } );

            selectedEntity.sensors = orderBy(sensors, ['name', 'id'], ['asc', 'asc']);
            
            entities[index] = selectedEntity;
            setEntities(entities);
            setState({
                available:   sensors ? orderBy(sensors, ['name', 'id'], ['asc', 'asc']) : [],
                unavailable: [],
                draggedItem: {}
            });
        }

        setActiveTab(selectedEntity);    
        setSelectedSite('');
        setExternalEntityList([]);
        setSelectedExternalEntity({});
        setExternalSensorList([]);
        setSelectedExternalSensors([]);
    };

    const handleItemClick = (event, data, connectedData) => {
        const newData = [...state[data]];

        const current = newData.findIndex(
            (dataItem) => dataItem === event.dataItem
        );
        
        if (current >= 0) {
            if (newData[current][SELECTED_FIELD]) {
                newData[current][SELECTED_FIELD] = false;
            } else {
                newData[current][SELECTED_FIELD] = true;
            }
        }

        setState({
            ...state,
            [data]:          newData,
            [connectedData]: state[connectedData].map((item) => {
                item[SELECTED_FIELD] = false;
                return item;
            }),
        });
        
        updateSelectedSensorTypeList(event.dataItem, !event.dataItem.selected);
    };

    const handleSelectedItemClick = (event, data, connectedData) => {
        setState({
            ...state,
            [data]: state[data].map((item) => {
                if (item.id === event.dataItem.id) {
                    item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                } else if (!event.nativeEvent.ctrlKey) {
                    item[SELECTED_FIELD] = false;
                }
                return item;
            }),
            [connectedData]: state[connectedData].map((item) => {
                item[SELECTED_FIELD] = false;
                return item;
            }),
        });
    };

    const handleToolBarClick = e => {
        let toolName = e.toolName || '';
        let tempEntity = entities;
        let result = processListBoxData(state.available, state.unavailable, toolName, SELECTED_FIELD);

        let availableResult = result.listBoxOneData;
        let unavailableResult = result.listBoxTwoData;

        availableResult.map(item => {
            item.available = true;
            item.selected = false;
            item.order = -1;
            return item;
        });
    
        unavailableResult.map((item, index) => {
            item.available = false;
            item.selected = false;
            item.order = index;
            return item;
        });

        const equipmentTypeSensorOrder = sensorOrders.find(item => item.entityId === activeTab.id && item.equipmentTypeId === activeTab.isSystem ? activeTab.systemType.id : activeTab.equipmentType.id); //.orderedSensors = orderedUnavailable;
        if (!equipmentTypeSensorOrder) {
            const orders = {
                entityId:        activeTab.id,
                equipmentTypeId: activeTab.isSystem ? activeTab.systemType.id : activeTab.equipmentType.id,
                orderedSensors:  unavailableResult
            };
            sensorOrders.push(orders);
            setSensorOrders(sensorOrders);
            setOptimizationSensorsOrder(sensorOrders);
        }
        else {
            sensorOrders.find(item => item.entityId === activeTab.id && item.equipmentTypeId === activeTab.isSystem ? activeTab.systemType.id : activeTab.equipmentType.id).orderedSensors = unavailableResult;
            setSensorOrders(sensorOrders);
            setOptimizationSensorsOrder(sensorOrders);
        }

        const merged = [...availableResult, ...unavailableResult];

        const index = tempEntity.findIndex(
            (item) => item.id === activeTab.id
        );
        
        tempEntity[index].sensors = [ ...merged ];
        
        setEntities(tempEntity);

        setState({
            ...state,
            available:   availableResult,
            unavailable: unavailableResult
        });
    };

    const handleDragStart = e => {
        setState({
            ...state,
            draggedItem: e.dataItem
        });
    };

    const handleDrop = e => {
        let result = processListBoxDragAndDrop(
            state.available, 
            state.unavailable, 
            state.draggedItem, 
            e.dataItem, 
            'id'
        );
        
        result.listBoxOneData.forEach(item => {
            item.available = true;
            item.order = -1;
        });

        result.listBoxTwoData.forEach((item, index) => {
            item.available = false;
            item.order = index;
        });

        const equipmentTypeSensorOrder = sensorOrders.find(item => item.entityId === activeTab.id && item.equipmentTypeId === activeTab.isSystem ? activeTab.systemType.id : activeTab.equipmentType.id); //.orderedSensors = orderedUnavailable;
        if (!equipmentTypeSensorOrder) {
            const orders = {
                entityId:        activeTab.id,
                equipmentTypeId: activeTab ? activeTab.systemType.id : activeTab.equipmentType.id,
                orderedSensors:  result.listBoxTwoData
            };
            sensorOrders.push(orders);
            setSensorOrders(sensorOrders);
            setOptimizationSensorsOrder(sensorOrders);
        }
        else {
            sensorOrders.find(item => item.entityId === activeTab.id && item.equipmentTypeId === activeTab ? activeTab.systemType.id : activeTab.equipmentType.id).orderedSensors = result.listBoxTwoData;
            setSensorOrders(sensorOrders);
            setOptimizationSensorsOrder(sensorOrders);
        }
        
        setState({
            ...state,
            available:   result.listBoxOneData,
            unavailable: result.listBoxTwoData
        });
    };

    const addItem = () => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        formatlist.push({ 'operator': '', 'condition': '' });
        setFormatList([...formatlist]);
    };

    const removeItem = (index) => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        formatlist.splice(index, 1);
        setFormatList([...formatlist]);
    };

    // A utility function to check if given
    // two intervals overlap
    function doOVerlap(i1, i2) {
        if (i1.low < i2.high && i2.low < i1.high)
            return true;
        return false;
    }

    const updateFormat = (data, i, key) => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        if (formatlist[i]) {
            formatlist[i][key] = data;
        }
        else {
            let obj = {};
            obj[key] = data;
            formatlist.push(obj);
        }
        setFormatList([...formatlist]);
    };

    // The main function that searches a given
    // interval i in a given Interval Tree.
    function overlapSearch(root, i) {

        // Base Case, tree is empty
        if (root == null)
            return null;

        // If given interval overlaps with root
        if (doOVerlap(root.i, i))
            return root.i;

        // If left child of root is present
        // and max of left child is greater
        // than or equal to given interval,
        // then i may overlap with an interval
        // is left subtree
        if (root.left != null &&
            root.left.max >= i.low)
            return overlapSearch(root.left, i);

        // Else interval can only
        // overlap with right subtree
        return overlapSearch(root.right, i);
    }

    // A utility function to insert a new
    // Interval Search Tree Node. This is
    // similar to BST Insert. Here the
    // low value of interval is used to
    // maintain BST property
    function insert(root, i) {

        // Base case: Tree is empty,
        // new node becomes root
        if (root == null)
            return newNodeSingle(i);

        // Get low value of interval at root
        var l = root.i.low;

        // If root's low value is smaller,
        // then new interval goes to left subtree
        if (i.low < l)
            root.left = insert(root.left, i);

        // Else, new node goes to right subtree.
        else
            root.right = insert(root.right, i);

        // Update the max value of this
        // ancestor if needed
        if (root.max < i.high)
            root.max = i.high;
        return root;
    }

    // This function prints all conflicting
    // appointments in a given array of apointments.
    function printConflicting(appt, n) {

        // Create an empty Interval Search
        // Tree, add first appointment
        var root = null;
        root = insert(root, appt[0]);

        // Process rest of the intervals
        for (var i = 1; i < n; i++) {

            // If current appointment conflicts
            // with any of the existing intervals,
            // print it
            var res = overlapSearch(root, appt[i]);

            if (res != null) {
                appt[i].conflicted = true;
                res.conflicted = true;
            }
            // Insert this appointment
            root = insert(root, appt[i]);
        }
    }
    
    class ITNode {
        // 'i' could also be a normal variable
        constructor() {
            this.max = 0;
            this.left = null;
            this.right = null;
            this.i = null;
        }
    }

    //Ref - https://www.geeksforgeeks.org/interval-tree/
    class Interval {
        constructor() {
            this.low = 0;
            this.high = 0;
        }
    }
        
    // A utility function to create a new node
    function newNodeDouble(l, h) {
        var temp = new Interval();
        temp.low = l;
        temp.high = h;
        return temp;
    }
    
    // A utility function to create a new node
    function newNodeSingle(i) {
        var temp = new ITNode();
        temp.i = i;
        temp.max = i.high;
        temp.left = temp.right = null;
        return temp;
    }
        
    const validateConditions = () => {
        const intervals = [];
        formatList.forEach(c => {
            if (c.operator === 'Greater Than') {
                intervals.push(newNodeDouble(c.field1, Number.MAX_SAFE_INTEGER));
            }
            else if (c.operator === 'Less Than') {
                intervals.push(newNodeDouble(0, c.field1));
            }
            else if (c.operator === 'Between') {
                intervals.push(newNodeDouble(c.field1, c.field2));
            }
            else if (c.operator === 'Equals') {
                intervals.push(newNodeDouble(c.field1, c.field1));
            }
        });
        printConflicting(intervals, intervals.length);
        return intervals;
    };

    const handleSubmit = (data, key) => {
        if (formatType === 'numeric') {
            let gaps = validateConditions();
            let formatlist = formatList;
            let conflict = false;
            gaps.forEach((c, i) => {
                formatlist[i].conflicted = c.conflicted ? true : false;
                if (c.conflicted)
                    conflict = true;
            });
            if (conflict) {
                setFormatList([...formatlist]);
                return false;
            }
        }
        let obj = formatObj;
        obj[formatKey] = JSON.parse(JSON.stringify(formatList));
        setFormatObj(obj);
        return true;
    };

    const handleSiteChange = async (event, site) => {
        if (!site) {
            return;
        }

        setExternalEntityLoading(true);
        setSelectedExternalEntity({});
        setExternalEntityList([]);
        setSelectedExternalSensors([]);
        setExternalSensorList([]);

        let equipments = await fetchReportEquipment(site.id);
        equipments = sortBy(equipments, 'name');

        let systems = await fetchReportSystems(site.id);
        systems = sortBy(systems, 'name');

        setSelectedSite(site);
        setExternalEntityList([...equipments, ...systems]);
        setExternalEntityLoading(false);
    };

    const handleExternalEntityChange = async (event, entity) => {
        if (!entity) {
            return;
        }

        setExternalSensorsLoading(true);
        setSelectedExternalSensors([]);
        setExternalSensorList([]);

        let sensors = await fetchEntitySensors(site.id, entity.id);
        
        setSelectedExternalEntity(entity);
        setExternalSensorList(sensors);
        setExternalSensorsLoading(false);
    };

    const handleConfirmation = ()=> {
        setExternalSensorOpen(false);
    };

    const submitFormula = () => {
        setExternalSensorOpen(false);

        let tempSensors = [...selectedExternalSensors];
        let uniqueSensors = [];

        tempSensors.forEach(item => {
            let existingSensor = state.available.filter(s => s.id === item.id);
            if (isEmpty(existingSensor)) {
                uniqueSensors.push(item);
            }
        });

        uniqueSensors.forEach(item => {
            item.isExternal = true;
            item.entityName = selectedExternalEntity.name;
            item.available = true;
        });

        let allSensors = [...uniqueSensors, ...state.available];

        setState({
            available:   allSensors,
            unavailable: [],
            draggedItem: {}
        });
    };

    const handleExternalSensorsChange = (event, values) => {
        if (values.length !== externalSensorList.length) {
            let updatedValues = [...values];
            updatedValues = updatedValues.filter(item => item.id !== 0);
            setSelectedExternalSensors(updatedValues);
        } else {
            setSelectedExternalSensors(values);
        }
    };

    const checkTabItem = (tabItem) => {
        if (isEmpty(tabItem.sensors)) {
            return false;
        } else {
            let tempSensors = tabItem.sensors.filter(item => !item.available);
            if (!isEmpty(tempSensors)) {
                return true;
            }
        }
        
        return false;
    };

    let activeSensor = {};
    let selectedSensor = state.unavailable.filter(item => item.selected);
    if (!isEmpty(selectedSensor)) {
        activeSensor = selectedSensor[0];
    }

    const handleOpenFilterPanel = e => {
        const distinctTypes = [...new Map([...selectedSensorTypes].map(item => [item['id'], item])).values()];
        const fieldsList = [];
    
        orderBy(distinctTypes, ['sensorType.name'], ['asc']).forEach(type => {
            const filterType = type.displayDataType === 'text' ? TextFilter : type.displayDataType === 'float' || type.displayDataType === 'integer' ? NumericFilter : type.displayDataType === 'boolean' ? BooleanFilter : TextFilter;
            const operatorList = type.displayDataType === 'text' ? Operators.text : type.displayDataType === 'float' || type.displayDataType === 'integer' ? Operators.numeric : type.displayDataType === 'boolean' ? Operators.boolean : Operators.text;
            fieldsList.push({
                name:      type.sensorType ? type.sensorType.id : type.id,
                label:     type.sensorType ? type.sensorType.name : type.name,
                filter:    filterType,
                operators: operatorList
            });
        });
        setFilterFields(fieldsList);

        setShowFilterPanel(true);
    };

    const clearAppliedFilter = e => {
        setReportFilter();
        setFilterText('');
    };

    const updateSelectedSensorTypeList = (dataItem, selected) => {
        const sensorTypeCheckedCount = state.available.filter(st => st.checked && st.sensorType.id === dataItem.sensorType.id).length;
        const exists = selectedSensorTypes.filter(st => st.id === dataItem.sensorType.id).length > 0;
        const newSensorTypeList = [...selectedSensorTypes];
        if (selected) {
            // add to the selectedSensorType if it doesn't exist
            if (!exists) {
                setSelectedSensorTypes(selectedSensorTypes => [...selectedSensorTypes, dataItem]);
            }
        }
        else {
            // remove if it is the last one of that type
            if (exists && sensorTypeCheckedCount === 0) {
                setSelectedSensorTypes(newSensorTypeList.filter(st => st.id !== dataItem.sensorType.id));
            }
        }
    };

    const removeTab = tab => {
        isRemovingTab = true;
        if (tab.isSystem) {
            const removeSystem = selectedSystems.find(se => se.id === tab.id);
            removeSystem.sensors?.forEach(e => e.available = true);
            const tempSystem = selectedSystems.filter(se => se.id !== tab.id);
            setSelectedSystems(tempSystem);
        } else {
            const removeEquipment = selectedEquipment.find(se => se.id === tab.id);
            removeEquipment.sensors?.forEach(e => e.available = true);
            const tempEquipment = selectedEquipment.filter(se => se.id !== tab.id);
            setSelectedEquipments(tempEquipment);
        }
        const filteredSensorOrders = sensorOrders.filter(so => so.entityId !== tab.id);
        setSensorOrders(filteredSensorOrders);
        const filteredOptimizationSensorsOrder = optimizationSensorsOrder.filter(so => so.entityId !== tab.id);
        setOptimizationSensorsOrder(filteredOptimizationSensorsOrder);

        // reset available sensors flag
        const removedItemIndex = entities.findIndex(e => e.id === tab.id);
        if (removedItemIndex !== -1) {
            const sensors = entities[removedItemIndex].sensors;
            sensors?.forEach(s => s.available = true);
            entities[removedItemIndex].sensors = sensors ? sensors : [];
        }
    };
    
    const Title = (props) => {
        if (checkTabItem(props.tab)) {
            return (
                <>
                    <span style={{ paddingRight: '5px', fontSize: '12px' }}>
                        {props.tab.name}
                    </span>
                    <span
                        className="material-icons-outlined"
                        style={{ fontSize: '14px' }}
                    >
                        done
                    </span>
                    <span className="k-spacer" />
                    <span role={'none'} className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base k-icon-button" onClick={() => props.onTabRemove(props.tab)}>
                        <span className="k-icon k-i-x" />
                    </span>
                </>
            );
        } else {
            return (
                <>
                    <span style={{ paddingRight: '5px', fontSize: '12px' }}>
                        {props.tab.name}
                    </span>
                    <span
                        className="material-icons-outlined"
                        style={{ fontSize: '14px' }}
                    >
                        report_problem
                    </span>
                    <span className="k-spacer" />
                    <span role={'none'} className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base k-icon-button" onClick={() => props.onTabRemove(props.tab)}>
                        <span className="k-icon k-i-x" />
                    </span>
                </>
            );
        }
    };

    const applyToAll = async () => {
        setIsApplyToAll(true);
        let tempEquipments = [];
        let tempSystems = [];
        let allEquipmentEntityWithSensors = [];
        let allSystemEntityWithSensors = [];
        let allEntityWithSensors = [];

        const baseIndex = baseCopyTabs.findIndex(bt => bt.entityType === activeTab.isSystem ? activeTab.systemType.Id : activeTab.equipmentType.id);
        if (baseIndex === -1) {
            // find the sensors from the base
            const baseSensors = optimizationSensorsOrder.find(os => os.entityId === activeTab.isSystem ? activeTab.systemType.id : activeTab.equipmentType.id);
            const base = {
                entityType:     activeTab.isSystem ? activeTab.systemType.id : activeTab.equipmentType.id,
                orderedSensors: baseSensors ? baseSensors.orderedSensors : []
            };
            setBaseCopyTabs([...baseCopyTabs, base]);
        }
        else {
            const base = baseCopyTabs[baseIndex];
            // find the orderedSensors in case they have changed
            const baseSensors = optimizationSensorsOrder.find(os => os.entityTypeId === base.entityType);
            base.orderedSensors = baseSensors ? baseSensors.orderedSensors : [];
        }

        if (!activeTab.isSystem && activeTab.equipmentType.id) {
            let result = equipmentList.filter(el => selectedEquipment.findIndex(se => se.id === el.id) < 0 && el.equipmentType && 
                el.equipmentType.id === activeTab.equipmentType.id);
            tempEquipments = [
                ...result
            ];
            allEquipmentEntityWithSensors = await fetchAllEntitySensors(site.id, [...tempEquipments], [], activeTab);
            allEntityWithSensors = [ ...selectedEquipment, ...allEquipmentEntityWithSensors, ...selectedSystems];
            setSelectedEquipments(allEntityWithSensors);
        }

        if (activeTab.isSystem && activeTab.systemType.id) {
            let result = systemList.filter(sl => selectedSystems.findIndex(ss => ss.id === sl.id) < 0 && sl.systemType && 
                sl.systemType.id === activeTab.systemType.id);
            tempSystems = [
                ...result
            ];
            allSystemEntityWithSensors = await fetchAllEntitySensors(site.id, [], [...tempSystems], activeTab);
            allEntityWithSensors = [...selectedEquipment, ...selectedSystems, ...allSystemEntityWithSensors];
            setSelectedSystems(allEntityWithSensors);
        }
        
        setEntities(allEntityWithSensors);
    };

    const getEntityType = () => {
        let type = '';
        if (activeTab.isSystem && activeTab.systemType.name) {
            type = activeTab.systemType.name;
        } else if (activeTab.equipmentType.name) {
            type = activeTab.equipmentType.name;
        }
        
        return type;
    };

    const handleTabSelect = tab => {
        if (!isRemovingTab) {
            handleChange(tab);
        }
        else {
            if (selectedTab === tab.selected) {
                if (tab.selected === 0 && entities.length !== 0)
                {
                    setSelectedTab(0);
                }
            }
            isRemovingTab = false;
        }
    };

    return (
        <React.Fragment>
            { !isEmpty(entities) ? 
                <div className={classes.TabContainer} style={{ padding: '10px' }}>
                    <style>
                        {
                            `
                                .k-tabstrip-content.k-active, .k-tabstrip > .k-content.k-active {
                                    display: none;
                                }
                            `
                        }
                    </style>
                    <TabStrip
                        selected={selectedTab}
                        onSelect={handleTabSelect}
                        scrollable={true}
                        style={{
                            userSelect: 'none'
                        }}
                    >
                        {entities.map((tab, index) => {
                            return (
                                <TabStripTab title={<Title tab={tab} onTabRemove={removeTab} />} key={index} />
                            );
                        })}
                    </TabStrip>
                </div>
                : null 
            }
            <div>
                {
                    !isEmpty(activeTab) && !isEmpty(entities) ?
                        bobLoading.includes('FetchEntitySensors') ?
                            <div className={classes.LoadingContainer}>
                                <img className={classes.Loader} src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                            </div>
                            :
                            !isEmpty(entities) ?
                                <div>
                                    <div className={classes.ActionWrapper}>
                                        <div className={classes.InfoWrapper}>
                                            <span className="material-icons-outlined md-18">info</span>
                                            <span className={classes.Info}>
                                                Rearrange the sensors to reflect in the report.
                                                Select a sensor to conditionally format the column.
                                            </span>
                                        </div>
                                        <div className={classes.ActionContainer}>
                                            <BobActionMenu 
                                                entityType={getEntityType()}
                                                type="OptimizationReport"
                                                applyToAll={applyToAll}
                                            />
                                        </div>
                                    </div>
                                    <div className={classes.SensorListContainer} style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <div className={classes.ListContainer}>
                                            {
                                                document.getElementById(`tab-has-error-${activeTab.id}`) !== null ?
                                                    <div className={classes.ErrorMsg}>
                                                        <span className={clsx('material-icons-outlined md-18', classes.ErrorIcon)}>
                                                            error
                                                        </span>
                                                        <span>Please select a sensor</span>
                                                    </div> 
                                                    : null
                                            }
                                            <style>
                                                {
                                                    `
                                                .k-list-item.k-selected, .k-selected.k-list-optionlabel { color: black; font-weight: 600; }
                                                .k-list-item.k-selected:hover, .k-selected.k-list-optionlabel:hover, .k-list-item.k-selected.k-hover, .k-selected.k-hover.k-list-optionlabel { color: black; font-weight: 600; }
                                                `
                                                }
                                            </style>
                                            <div className={classes.ListFlexContainer}>
                                                <div>
                                                    <div>
                                                        <div className={classes.Info} style={{padding: '1rem'}}>Available Sensors</div>
                                                        <div style={{display: 'flex'}}>
                                                            <div className={classes.SearchContainer}>
                                                                <span className={clsx('material-icons-outlined md-18', classes.SearchBar)}>
                                                                    search
                                                                </span>
                                                                <TextField
                                                                    value={availableSearch}
                                                                    onChange={(e) => setAvailableSearch(e.target.value)}
                                                                    className={classes.margin}
                                                                    id="input-with-icon-textfield"
                                                                    placeholder="Search by keyword"
                                                                    InputProps={{
                                                                        style:            { fontSize: '1.2rem' },
                                                                        disableUnderline: true
                                                                    }}
                                                                    InputLabelProps={{
                                                                        style: { color: '#c6c6c6' },
                                                                    }}
                                                                />
                                                            </div>
                                                            <button className={clsx(`circle-white`, classes.PlusIcon)} title={'Add external sensor'} onClick={() => setExternalSensorOpen(true)}>
                                                                <i className={`fa fa-plus`} aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <ListBox
                                                            style={{
                                                                height:    '40vh',
                                                                width:     '36rem',
                                                                minHeight: '25.8rem',
                                                                maxHeight: '66rem',
                                                            }}
                                                            item={OptimizationReportCustomListItem}
                                                            selectedField={SELECTED_FIELD}
                                                            data={availableSearch ? state.available.filter(item => item.id === 'select' || item.name.toLowerCase().includes(availableSearch.toLowerCase())) : state.available}
                                                            textField="name"
                                                            onItemClick={(e) =>
                                                                handleItemClick(e, 'available', 'unavailable')
                                                            }
                                                            onDragStart={handleDragStart}
                                                            onDrop={handleDrop}
                                                            toolbar={() => {
                                                                return (
                                                                    <ListBoxToolbar
                                                                        tools={[
                                                                            'moveUp',
                                                                            'moveDown',
                                                                            'transferTo',
                                                                            'transferFrom',
                                                                            'transferAllTo',
                                                                            'transferAllFrom'
                                                                        ]}
                                                                        data={state.available}
                                                                        dataConnected={state.unavailable}
                                                                        selectedField={SELECTED_FIELD}
                                                                        onToolClick={handleToolBarClick}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <style>
                                                        {
                                                            `
                                                            .k-listbox .k-list-scroller .k-list.k-list-md{ { height: auto; max-height: 100%; }
                                                            `
                                                        }
                                                    </style>
                                                    <div style={{ paddingLeft: '1.3rem' }}>
                                                        <div className={classes.Info} style={{padding: '1rem'}}>Selected Sensors</div>
                                                        <div className={classes.SelectedSearchContainer}>
                                                            <span className={clsx('material-icons-outlined md-18', classes.SearchBar)}>
                                                                search
                                                            </span>
                                                            <TextField
                                                                value={selectedSearch}
                                                                onChange={(e) => setSelectedSearch(e.target.value)}
                                                                className={classes.margin}
                                                                id="input-with-icon-textfield"
                                                                placeholder="Search by keyword"
                                                                InputProps={{
                                                                    disableUnderline: true
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <ListBox
                                                        style={{
                                                            height:      '40vh',
                                                            width:       '29rem',
                                                            minHeight:   '25.8rem',
                                                            maxHeight:   '66rem',
                                                            paddingLeft: '12px',
                                                        }}
                                                        onItemClick={(e) =>
                                                            handleSelectedItemClick(e, 'unavailable', 'available')
                                                        }
                                                        item={OptimizationReportCustomListItem}
                                                        data={selectedSearch ? state.unavailable.filter(item => item.id === 'select' || item.name.toLowerCase().includes(selectedSearch.toLowerCase())) : orderBy(state.unavailable, 'order', 'asc')}
                                                        selectedField={SELECTED_FIELD}
                                                        textField="name"
                                                        onDragStart={handleDragStart}
                                                        onDrop={handleDrop}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={classes.ConditionalFormatContainer}>
                                            {
                                                !isEmpty(activeSensor) ?
                                                    <div className={classes.Info}>{`Conditional Formatting - ${activeSensor.name}`}</div>
                                                    : <div className={classes.Info}>{`Conditional Formatting`}</div>
                                            }
                                            {
                                                !isEmpty(activeSensor) ?
                                                    <ConditionalFormat
                                                        formatList={activeTab.conditionalFormats ? activeTab.conditionalFormats : formatList}
                                                        formatKey={formatKey}
                                                        fieldType={formatType}
                                                        addItem={addItem}
                                                        removeItem={removeItem}
                                                        updateFormat={updateFormat}
                                                        submitFormat={handleSubmit}
                                                    />
                                                    : null
                                            }
                                        </div>
                                    </div>
                                </div>
                                : null
                        : null
                }
            </div>
            { process.env.isComplexFilterOptimizationReportEnabled && !isEmpty(activeTab) && !isEmpty(entities) ? 
                <div className={classes.FilterRow}>
                    <Button 
                        icon="filter"
                        size="small"
                        fillMode="flat"
                        rounded="medium"
                        onClick={handleOpenFilterPanel}
                        style={{textTransform: 'capitalize'}}
                    />
                    { filterText !== '' ? 
                        <Button
                            icon="clear"
                            size="small"
                            fillMode="flat"
                            rounded="medium"
                            onClick={clearAppliedFilter}
                            style={{textTransform: 'capitalize', marginLeft: '10px'}}
                        >
                            Clear
                        </Button>
                        : null
                    }
                    <span className={classes.filterText}>{filterText}</span>
                </div>
                : null
            }
            {
                process.env.isComplexFilterOptimizationReportEnabled && showFilterPanel ? 
                    <KendoFilterGridModal
                        title={'Optimization Report Filter Builder'}
                        filterModalOpen={showFilterPanel}
                        setFilterModalOpen={setShowFilterPanel}
                        filter={reportFilter}
                        filterText={filterText}
                        fields={filterFields}
                        setFilter={setReportFilter}
                    />
                    : null
            }
            {
                externalSensorOpen ?
                    <BobModal
                        confirmText="Add"
                        cancelText="Cancel"
                        rootClass={'external-sensor-modal external-sensor-modal1'}
                        onCancel={handleConfirmation}
                        onClose={handleConfirmation}
                        onConfirm={submitFormula}
                        open={externalSensorOpen}
                        title={'External Sensor'}
                    >
                        <div className={classes.LblRow}>
                            <span className={classes.LblField}>Client</span>
                            <span className={classes.LblFieldDark}>{selectedClient.name}</span>
                        </div>
                        <div className={classes.formRow}>
                            <FormControl className={classes.inputWrapper}>
                                <AutoComplete
                                    id="site"
                                    name="site"
                                    options={sortBy(siteList, 'name')}
                                    getOptionLabel={(option) => option.name || ''}
                                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                    value={selectedSite}
                                    onChange={handleSiteChange}
                                    size="small"
                                    required
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            className={classes.Required}
                                            label="Site"
                                            variant="outlined"
                                            required={true}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />}
                                />
                            </FormControl>
                        </div>
                        <div className={classes.formRow}>
                            <FormControl className={classes.inputWrapper}>
                                <AutoComplete
                                    id="entity"
                                    name="entity"
                                    disabled={isEmpty(selectedSite)}
                                    options={sortBy(externalEntityList, 'name')}
                                    getOptionLabel={(option) => option.name || ''}
                                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                    value={selectedExternalEntity}
                                    onChange={handleExternalEntityChange}
                                    size="small"
                                    required
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            className={classes.Required}
                                            label="Entity"
                                            variant="outlined"
                                            required={true}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {externalEntityLoading ? <CircularProgress color="inherit" size={15} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />}
                                />
                            </FormControl>
                        </div>
                        <div className={classes.formRow}>
                            <FormControl className={classes.inputWrapper}>
                                <AutoComplete
                                    id="externalSensors"
                                    name="externalSensors"
                                    disabled={isEmpty(selectedExternalEntity)}
                                    multiple
                                    disableCloseOnSelect
                                    options={externalSensorList}
                                    getOptionLabel={(option) => option.name || ''}
                                    getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
                                    value={selectedExternalSensors}
                                    onChange={handleExternalSensorsChange}
                                    size="small"
                                    renderTags={(value, getTagProps) => value.map((option, index) => {
                                        if (index < 2) {
                                            return (
                                                <Chip
                                                    classes={{
                                                        root: classes.Chip
                                                    }}
                                                    variant="outlined"
                                                    label={option.name}
                                                    {...getTagProps({ index })}
                                                />
                                            );
                                        } else if (index === 2) {
                                            return (<span className={classes.Tag}>{` + ${value.length - 2} Selected`}</span>);
                                        } else {
                                            return null;
                                        }
                                    })}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                value={option.id}
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.name}
                                        </React.Fragment>
                                    )}
                                    required
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            className={classes.Required}
                                            label="External Sensors"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {externalSensorsLoading ? <CircularProgress color="inherit" size={15} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />}
                                />
                            </FormControl>
                        </div>
                    </BobModal>
                    : null
            }
            {
                bobLoading.includes('fetchAllEntitySensors') || bobLoading.includes('fetchConfigurations') ?
                    <BobLoadingMask
                        className={classes.Loader}
                    />
                    : null
            }
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    bobLoading:    state.bob.bobLoading,
    entitySensors: state.reporting.entitySensors
});

const mapDispatchToProps = {
    ...BobActions,
    ...ReportingActions
};

export default connect(mapStateToProps, mapDispatchToProps)(OptimizationReportTabPane);
